import script from "./BaseSupplementsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseSupplementsModal.vue?vue&type=script&setup=true&lang=ts"

import "./BaseSupplementsModal.vue?vue&type=style&index=0&id=feb68542&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-feb68542"]])

export default __exports__